import {Axios2} from "../main";

async function getBalance() {
    return await Axios2.get('/user/wallet/balance');
}

async function getWalletLog(param) {
    return await Axios2.get('/user/wallet',{
        params:param
    });
}

async function chargeWallet(param) {
    return await Axios2.post('/user/wallet/charge', param);
}

export {
    getBalance,
    getWalletLog,
    chargeWallet
}